import { render, staticRenderFns } from "./MatchResults.vue?vue&type=template&id=3975811c&scoped=true&"
import script from "./MatchResults.vue?vue&type=script&lang=js&"
export * from "./MatchResults.vue?vue&type=script&lang=js&"
import style0 from "./MatchResults.vue?vue&type=style&index=0&id=3975811c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3975811c",
  null
  
)

export default component.exports